<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <!-- rederizando componente alert -->
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>Contratos</b>
                        </h3>
                        <router-link tag="a" class="btn btn-primary pull-right" to="/administracao/contratos/novo" v-if="hasPermission('usuario.write')"> <i class="fa fa-plus"></i> Novo </router-link>
                    </div>

                    <div class="box-body">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <input type="text" class="form-control" v-model="filtros.pesquisa" placeholder="Pesquisa: Entre com NOME DA UNIDADE" @keyup.enter="getDataTable" />
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <select v-model="filtros.categoria_unidade" class="form-control">
                                        <option value>--Categoria da Unidade--</option>
                                        <option value="0">Pública (Local)</option>
                                        <option value="1">Município Pactuado (PPI)</option>
                                        <option value="2">Privada</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="form-group">
                                    <select v-model="filtros.tipo" class="form-control">
                                        <option value>--Tipo do Contrato--</option>
                                        <option value="0">Solicitante</option>
                                        <option value="1">Prestador</option>
                                    </select>
                                </div>
                            </div>
							<div class="col-md-2">
								<div class="form-group">
									<select v-model="filtros.situacao" class="form-control">
										<option value>--Situação--</option>
										<option value="1">Ativo</option>
										<option value="0">Inativo</option>
									</select>
								</div>
							</div>

                            <div class="col-md-2">
                                <div class="form-group">
                                    <button @click="getDataTable" class="btn btn-default btn-block"><span class="fa fa-filter"></span> Filtrar</button>
                                </div>
                            </div>
                        </div>

                        <div class="row" style="margin-top:15px">
                            <div class="col-sm-12 table-responsive">
                                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                                    <thead>
                                        <tr role="row">
                                            <th style="width: 10%;">ID
												<span @click="sortByKey('contratos.id')" class="icon-ordenacao">
                                                    <i :class="filtros.ordem && filtros.coluna == 'contratos.id' ? `fa fa-sort-numeric${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                                </span>
											</th>
                                            <th style="width: auto;">
                                                Unidade
												<span @click="sortByKey('unidades.nome')" class="icon-ordenacao">
                                                    <i :class="filtros.ordem && filtros.coluna == 'unidades.nome' ? `fa fa-sort-alpha${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                                </span>
                                            </th>
                                            <th style="width: auto;">Categoria</th>
                                            <th style="width: auto;">Tipo</th>
                                            <th style="width: auto;">Data Inicial</th>
                                            <th style="width: auto;">Data Final</th>
                                            <th style="width: auto;">Situação</th>
                                            <th style="width: 15%">Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="even" role="row" v-for="item in dataTable.data" :key="item.id">
                                            <td>{{ item.id }}</td>
                                            <td>{{ item.nome }}</td>
                                            <td>{{ item.categoria | categoriaUnidade }}</td>
                                            <td>{{ item.tipo | tipoContrato }}</td>
                                            <td>{{ item.data_inicial | dataFormatada }}</td>
                                            <td>{{ item.data_final | dataFormatada }}</td>
                                            <td>{{ item.situacao | situacao }}</td>
                                            <td>
                                                <router-link tag="button" class="btn btn-warning btn-sm" :to="`/administracao/contratos/atualizacao/${item.id}`" title="Editar">
                                                    <i style="font-size:12px" class="fa fa-fw fa-edit"></i>
                                                </router-link>
                                                <router-link tag="button" class="btn btn-success btn-sm" :to="`/administracao/contratos/procedimentos/${item.id}`" title=" Procedimentos do Contrato">
                                                    <i style="font-size:12px" class="fa fa-fw fa-list"></i>
                                                </router-link>
                                                <router-link tag="button" class="btn btn-info btn-sm" :to="`/administracao/contratos/subgrupos/${item.id}`" title="Subgrupos do Contrato">
                                                    <i style="font-size:12px" class="fa fa-fw fa-list-alt"></i>
                                                </router-link>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-sm-5">Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>

                                    <div class="col-sm-7" style="text-align:right">
                                        <laravue-pagination :limit="5" :data="dataTable" v-on:pagination-change-page="getDataTable">
                                            <span slot="prev-nav">&lt; Anterior</span>
                                            <span slot="next-nav">Próximo &gt;</span>
                                        </laravue-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http

export default {
    filters: {},
    data: () => ({
        filtros: {
            pesquisa: "",
            categoria_unidade: "",
			tipo: "",
			situacao: "",
			coluna: null,
			ordem: null
        },
        dataTable: {}
    }),
    mounted() {
        this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
        this.filtros.categoria_unidade = this.$route.query.categoria_unidade ? this.$route.query.categoria_unidade : "";
        this.filtros.tipo = this.$route.query.tipo ? this.$route.query.tipo : "";
        this.filtros.situacao = this.$route.query.situacao ? this.$route.query.situacao : "";
        this.getDataTable();
    },
    methods: {
		sortByKey: function (field) {
			this.filtros.coluna = field;
			if (this.filtros.ordem == 'asc') {
				this.filtros.ordem = 'desc';
			} else {
				this.filtros.ordem = 'asc';
			}
			this.getDataTable();
		},
        getDataTable(page) {
            if (typeof page === "undefined" || typeof page === "object") {
                page = 1;
            }
            this.filtros.page = page;
            this.$router.push({ query: this.filtros });

            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;
            axios
                .get(`${this.$store.state.serverURI}/api/administracao/contratos/getAllPaginate`, config)
                .then(response => {
                    this.dataTable = response.data;
                })
                .catch(error => {
                    this.$store.commit("throwException", error);
                });
        },
        delete(id, nome) {}
    },
    watch: {
        page: function(val) {
            this.getDataTable();
        }
    },

    components: {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// index.vue?6a2ddbfe